module.exports = __webpack_public_path__ + "static/media/background.200e4a9d.jpg";